import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { Label } from '@opengov/data-viz';
import classnames from 'classnames2';
import React from 'react';
import styles from './AxisName.scss';
export var createAxisName = function createAxisName(componentName, dataTest) {
  var rotate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // move logic out into here
  var textAnchor = componentName === 'AxisName.Y' ? 'end' : 'middle';
  var rotation = componentName === 'AxisName.Y' ? -90 : 0;

  var AxisNameComponent = function AxisNameComponent(_ref) {
    var text = _ref.text,
        x = _ref.x,
        y = _ref.y,
        dx = _ref.dx,
        dy = _ref.dy,
        dimmed = _ref.dimmed;
    return React.createElement(Label, {
      text: text,
      x: x,
      y: y,
      dx: dx,
      dy: dy,
      textAnchor: textAnchor,
      rotation: rotate ? rotation : 0,
      dataTest: dataTest,
      style: {
        text: classnames(styles.axisName, _defineProperty({}, styles.dim, dimmed))
      }
    });
  };

  AxisNameComponent.displayName = componentName;
  return AxisNameComponent;
};
export var AxisName = {
  X: createAxisName('AxisName.X', 'xAxisName'),
  Y: createAxisName('AxisName.Y', 'yAxisName'),
  UnrotatedY: createAxisName('AxisName.Y', 'yAxisName', false)
};